
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_r9eng_93",
  "variant-secondary": "awsui_variant-secondary_4c84z_r9eng_140",
  "variant-primary": "awsui_variant-primary_4c84z_r9eng_177",
  "variant-info": "awsui_variant-info_4c84z_r9eng_212",
  "variant-value-large": "awsui_variant-value-large_4c84z_r9eng_249",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_r9eng_285",
  "variant-recovery": "awsui_variant-recovery_4c84z_r9eng_320",
  "button": "awsui_button_4c84z_r9eng_355",
  "color-inverted": "awsui_color-inverted_4c84z_r9eng_392",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_r9eng_411",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_r9eng_416",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_r9eng_420",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_r9eng_424",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_r9eng_429",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_r9eng_434",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_r9eng_439",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_r9eng_444",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_r9eng_449",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_r9eng_455",
  "icon": "awsui_icon_4c84z_r9eng_455"
};
  